<template>
  <form class="" @submit.prevent="validateForm">
    <div class="mt-3 dashed-border pt-3">
      <div
        :class="[
          'border rounded py-[7px] px-[11px] text-[13px] flex dark:bg-black-light bg-grey-light gap-x-2 items-center relative focus-within:border-opacity-100',
          { 'text-red border-red': isSubmitAttempted && !calcFormStore.steamUsername || !loginCorrect},
          { 'text-black dark:text-white dark:border-white dark:border-opacity-30 border-black border-opacity-10': !(isSubmitAttempted && !calcFormStore.steamUsername || !loginCorrect)},
        ]"
      >
        <TheSteam width="16" height="16"/>
        <input
          v-model="calcFormStore.steamUsername"
          type="text"
          placeholder="Ваш логин Steam"
          class="input scroll-m-10 bg-white bg-opacity-0 text-[inherit] placeholder:text-[inherit] grow"
          @keyup="loginCorrect = true"
          @keyup.enter="hideKeyboard"
          @blur="submitLogin"
          ref="steamInput"
        />
        <div class="flex items-center gap-x-2"

             @mouseover="isShow = true"
             @mouseleave="isShow = false"
             @click="isShow = true"
        >
          <span class="text-opacity-60 underline cursor-pointer">Где найти?</span>
          <ThePrimaryInfo
              class="cursor-pointer text-primary"
              width="16" height="16"
          />
        </div>
      </div>
      <div class="text-red text-[13px]" v-if="!loginCorrect">
        Ошибка: Такого логина в стим не существует
      </div>
      <div class="text-red text-[13px]" v-else-if="isSubmitAttempted && !calcFormStore.steamUsername">
        Ошибка: Логин в Steam обязателен
      </div>
    </div>
    <div class="mt-2 flex items-center pl-3">
        <input v-model="calcFormStore.saveLogin" id="save_login" type="checkbox" value="1" class="hidden peer" name="save_login">
        <label for="save_login" class="cursor-pointer border-2 border-grey-light bg-grey-light dark:border-white rounded-full dark:bg-white peer-checked:[&_svg]:opacity-100">
          <Checked width="12" height="12" class="opacity-0 duration-100" />
        </label>
        <label for="save_login" class="cursor-pointer ml-2 dark:text-white text-black text-[12px]">Запомнить логин</label>
    </div>
    <transition name="slide-fade">
      <div
        class="info_img pointer mt-3 cursor-pointer"
        @mouseover="isShow = true"
        @mouseleave="isShow = false"
        v-if="isShow"
        @click="openGallery"
      >
        <img class="w-full h-full" src="@/assets/img/steam.jpg" alt="" />
      </div>
    </transition>

    <div class="mt-3 dashed-border pt-3">
      <div
        :class="[
          'border rounded py-[7px] px-[11px] text-[13px] flex dark:bg-black-light bg-grey-light gap-x-2 items-center relative focus-within:border-opacity-100',
          { 'text-red border-red': isSubmitAttempted && !calcFormStore.balance },
          { active_element: calcFormStore.balance },
          {'dark:border-white dark:border-opacity-30 border-black border-opacity-10': !(isSubmitAttempted && !calcFormStore.balance)}
        ]"
      >
        <TheTenge width="16" height="16" v-if="calcFormStore.selectedCurrency === 'KZT_RUB'" />
        <TheUsd width="16" height="16" v-if="calcFormStore.selectedCurrency === 'USD_RUB'" />
        <TheRuble width="16" height="16" v-if="calcFormStore.selectedCurrency === 'RUB_RUB'" />
        <input
          v-model="calcFormStore.balance"
          type="number"
          inputmode="numeric"
          pattern="[0-9]*"
          placeholder="минимум на сумму 10₽"
          @blur="validateBalance"
          @focus="!calcFormStore.balance && (calcFormStore.balance = prices[calcFormStore.selectedCurrency][0]) && console.log(calcFormStore.selectedCurrency)"
          :class="[
            'bg-white bg-opacity-0 text-[inherit] placeholder:text-[inherit] grow peer',
            {'opacity-0 focus-within:opacity-100': !calcFormStore.balance || calcFormStore.balance == 0}
          ]"
          @keyup.enter="hideKeyboard"
          ref="balanceInput"
          id="balance"
        />
        <label for="balance" 
          v-if="!(calcFormStore.balance > 0)"
          :class="[
          'absolute left-[35px] top-1/2 -translate-y-1/2 w-max peer-focus-within:hidden',
        ]">Сумма пополнения</label>
      </div>
      <div class="text-red text-[13px]" v-if="isSubmitAttempted && !calcFormStore.balance">
        Ошибка: Баланс обязателен
      </div>
      <div class="mt-2 text-[13px] text-black text-opacity-60 dark:text-white dark:text-opacity-60 flex items-center text-center gap-x-2">
        <button
          type="button"
          :class="[
            'rounded border border-primary p-[7px] grow w-0 min-w-0',
            {'text-white bg-primary': calcFormStore.balance == price}
          ]"
          v-for="price in currentPrices"
          :key="price"
          @click="putPrice(price)"
        >
          {{ `${price} ${currencySymbol[calcFormStore.selectedCurrency]}` }}
        </button>
      </div>
    </div>

    <div class="mt-2">
      <div
        :class="[
          'border rounded py-[7px] px-[11px] text-[13px] flex dark:bg-black-light bg-grey-light gap-x-2 items-center relative focus-within:border-opacity-100 dark:border-white dark:border-opacity-30 border-black border-opacity-10'
        ]"
      >
        <ThePromo />
        <input
          v-model="promoCode"
          type="text"
          placeholder="Промо-код"
          class="bg-white bg-opacity-0 text-[inherit] placeholder:text-[inherit] grow"
          @keyup.enter="hideKeyboard"
          @keyup="check_promocode"
          ref="promoInput"
        />
        <ThePrimaryInfo
          @click.prevent="emit('call-faq-method')"
            class="cursor-pointer text-primary"
            width="16" height="16"
        />
      </div>
      <div class="text-red text-[13px]" v-if="promoCode && promoCodeError">
        Ошибка: промокода не существует
      </div>
      <div class="text-[13px] text-[#00e083]" v-if="promoCode && discount_percent">
        Промокод успешно активирован. Скидка: {{discount_percent}}%
      </div>
    </div>

    <div class="mt-3 pt-3 dashed-border">
      <h3 class="text-black dark:text-white text-[18px]">Итог</h3>
      <p v-if="userStore.user?.vip.percent && !(promoCode && discount_percent)" class="mt-2 text-black dark:text-white text-[13px]">С учётом <span class="from-[#FFD900] to-[#FF4400] text-[transparent] bg-gradient-to-b bg-clip-text">VIP-статуса</span> (-{{userStore.user.vip.percent.toFixed(1).replace('.',',')}}%)</p>
      <div class="mt-2 rounded border border-black border-opacity-30 dark:border-white dark:border-opacity-30 bg-white dark:bg-black-light text-[13px] text-black dark:text-white">
        <div class="px-[11px] flex justify-between gap-x-2 py-[7px]">
          <p class="">Вы платите:</p>
          <p class="text-right font-semibold">
            <span v-if="personalDiscount">
              <span>{{ personalDiscount }}</span>&nbsp;₽
              <sup class="line-through dark:text-white text-opacity-60 text-black dark:text-opacity-60"><span>{{ Math.floor(calcFormStore.balanceWithCommission) }}</span>&nbsp;₽</sup>
            </span>
            <span v-else><span>{{ Math.floor(calcFormStore.balanceWithCommission) }}</span>&nbsp;₽</span>
          </p>
        </div>
        <div class="px-[11px] flex justify-between gap-x-2 py-[7px] pt-2 border-t border-black border-opacity-30 dark:border-white dark:border-opacity-30">
          <p class="">Вы получите:</p>
          <p class="text-right font-semibold">
            <span v-if="calcFormStore.selectedCurrency === 'USD'">{{ (formattedPrice || 0).toFixed(2) }}&nbsp;{{ currencySymbol[calcFormStore.selectedCurrency] }}</span>
            <span v-else>{{ Math.floor(formattedPrice) }}&nbsp;{{ currencySymbol[calcFormStore.selectedCurrency] }}</span>
          </p>
        </div>
      </div>
    </div>

    <h3 class="mt-4 text-[18px] text-black dark:text-white">Способ оплаты</h3>
    <div class="mt-2 grid grid-cols-2 gap-x-2 p-3 bg-primary bg-opacity-10 dark:bg-blue-dark dark:bg-opacity-40 rounded text-[13px]">
      <div class="">
        <input v-model="calcFormStore.paymentType" id="payment_sbp" name="payment_type" type="radio" class="hidden peer" checked value="sbp">
        <label for="payment_sbp" class="flex items-center justify-center gap-x-2 text-center py-2 peer-checked:bg-primary peer-checked:text-white border-primary rounded border cursor-pointer text-black text-opacity-60 dark:text-white dark:text-opacity-60">
            <SbpLogo class="w-[13px] h-auto"/>
            СБП
        </label>
      </div>
      <div class="">
        <input v-model="calcFormStore.paymentType" id="payment_card" name="payment_type" type="radio" class="hidden peer" value="card">
        <label for="payment_card" class="flex items-center justify-center gap-x-2 text-center py-2 peer-checked:bg-primary peer-checked:text-white border-primary rounded border cursor-pointer text-black text-opacity-60 dark:text-white dark:text-opacity-60">
            <CardLogo width="16" height="16"/>
            Картой
        </label>
      </div>
    </div>
    <div class="mt-2 flex items-center pl-3">
      <input v-model="isAgreementAccepeted" id="agreement" type="checkbox" value="0" class="hidden peer" name="agreement">
      <label for="agreement" class="cursor-pointer border-2 border-grey-light bg-grey-light dark:border-white rounded-full dark:bg-white peer-checked:[&_svg]:opacity-100">
          <Checked width="12" height="12" class="opacity-0 duration-100" />
      </label>
      <label for="agreement" class="cursor-pointer ml-2 dark:text-white text-black text-[12px]">Согласен с условиями <a @click="webapp && webapp.openLink($event.target.href) || $event.preventDefault()" class="underline" href="/Пользовательское соглашениe.pdf">Пользовательского соглашения</a> и <a @click="webapp && webapp.openLink($event.target.href) || $event.preventDefault()" class="underline" href="/Политика конфиденциальности.pdf">Политики конфиденциальности</a></label>
    </div>
    <div class="mt-4">
      <button :disabled="isSubmitting || !isAgreementAccepeted || !calcFormStore.balance" class="text-white bg-primary rounded p-3 text-center text-[15px] font-semibold w-full disabled:opacity-50"
        @click="validateForm"
      >
        <span v-if="calcFormStore.balance">
          Оплатить
          {{ calcFormStore.balanceWithCommission ? personalDiscount || Math.floor(calcFormStore.balanceWithCommission) : '' }}&nbsp;₽
        </span>
        <span v-else>Укажите сумму</span>
      </button>
      <p class="mt-2 text-[13px] text-black text-opacity-60 dark:text-white dark:text-opacity-60">
        Среднее время пополения 5 секунд с момента
        оплаты
      </p>
    </div>
  </form>
  <transition name="slide-fade">
    <TheGallery v-if="isOpen" @close="isOpen = false" />
  </transition>
</template>
<script setup lang="ts">
import { computed, ref, onMounted, defineEmits, watch } from "vue";
import TheSteam from "@/assets/icons/steam-icon-small.svg";
import ThePrimaryInfo from "@/assets/icons/circle-question.svg";
import TheTenge from "@/assets/icons/circle-tenge.svg";
import TheUsd from "@/assets/icons/circle-dollar.svg";
import TheRuble from "@/assets/icons/circle-ruble.svg";
import ThePromo from "@/assets/icons/tag.svg";
import ThePercent from "@/components/icons/ThePercent.vue";
import TheGallery from "@/components/TheGallery.vue";
import { useCurrencyStore } from "@/stores/currencyStore";
import { useUserStore } from '@/stores/userStore';
import { useYandexMetrika } from 'yandex-metrika-vue3'
import { calcStorage, useCalcFormStore } from "@/stores/calcFormStore";
import { useDebounceFn } from "@vueuse/core";
import { useCreatePaymentLink } from "@/composables/useCreatePaymentLink";
import SbpLogo from './icons/SbpLogo.vue';
import CardLogo from "@/assets/icons/credit-card.svg";
import Checked from "@/assets/icons/checked.svg";


const yandexMetrika = useYandexMetrika()

const emit = defineEmits(['call-faq-method'])

const currencyStore = useCurrencyStore();
const steamInput = ref<HTMLInputElement | null>(null);
const balanceInput = ref<HTMLInputElement | null>(null);
const promoInput = ref<HTMLInputElement | null>(null);
const isShow = ref(false);
const isOpen = ref(false);
const promoCode = ref<string | null>(null);
const isSubmitAttempted = ref(false);
const loginCorrect = ref(true)
const promoCodeError = ref(false)
const discount_percent = ref(0)
const webapp = window.Telegram.WebApp;
const isSubmitting = ref(false);
const isAgreementAccepeted = ref(true);
const userStore = useUserStore();

const calcFormStore = useCalcFormStore();
let usernameChecking = Promise.resolve();

// Определение предустановленных значений для каждой валюты
const prices = {
  RUB_RUB: [100, 500, 1000, 5000],
  KZT_RUB: [1000, 5000, 15000, 30000],
  USD_RUB: [5, 25, 50, 100],
};

const currencySymbol = {
  RUB_RUB: '₽',
  KZT_RUB: '₸',
  USD_RUB: '$',
}

// Использование computed свойства для динамического обновления списка цен
const currentPrices = computed(() => {
  return prices[calcFormStore.selectedCurrency] || prices.RUB_RUB; // По умолчанию RUB
});

const personalDiscount = computed(() => {
  if (calcFormStore.balanceWithCommission && userStore.user?.vip.percent && !(promoCode.value && discount_percent.value)) {
    const currencyPriceAmmount = calcFormStore.balance * parseFloat(calcFormStore.rates[calcFormStore.selectedCurrency]);
    const commissionAmount = currencyPriceAmmount / 100 * (calcFormStore.rates.commission - userStore.user.vip.percent);
    return currencyPriceAmmount + commissionAmount;
  }
  return 0
})


const formattedPrice = computed(() => {
  // return balance.value ? balance.value / parseFloat(rates.value[
  //     currencyStore.selectedCurrency
  //     ]) : 0;
  return calcFormStore.balance
});

function hideKeyboard() {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
}
function putPrice(price: number) {
  calcFormStore.balance = price;
}
function openGallery() {
  isOpen.value = !isOpen.value;
  hideKeyboard();
}
async function validateForm() {
  isSubmitting.value = true;
  await usernameChecking;
  isSubmitAttempted.value = true;
  hideKeyboard();

  if (calcFormStore.steamUsername && loginCorrect.value) {
    calcStorage.set('saveLogin', calcFormStore.saveLogin);
    if (calcFormStore.saveLogin) {
      calcStorage.set('steamUsername', calcFormStore.steamUsername);
    } else {
      calcStorage.set('steamUsername', '')
    }
    await useCreatePaymentLink(personalDiscount.value);
    if (calcFormStore.paymentLink) {
      if (webapp.initData) {
        try {
          webapp.openLink(calcFormStore.paymentLink)
        }
        catch (error) {
          window.location.href = calcFormStore.paymentLink;
        }
      } else {
        window.location.href = calcFormStore.paymentLink;
      }
    }
  }

  isSubmitting.value = false;

}

async function validateBalance() {
  const rate = parseFloat(calcFormStore.rates[calcFormStore.selectedCurrency])
  const price = calcFormStore.balance * rate;
  if (price < 10) {
    calcFormStore.balance = Math.floor(10 / rate);
  }

  if (price > 1000000) {
    calcFormStore.balance = 1000000 / rate;
  }
}

async function submitLogin() {
  usernameChecking = new Promise(async res => {
    await usernameChecking;
    if (!calcFormStore.steamUsername) {
      loginCorrect.value = false;
      steamInput.value.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      res();
      return;
    }
  
    await calcFormStore.checkUsername();
    
    if (calcFormStore.transactionId) {
      // --- ОТПРАВКА СОБЫТИЯ STEAM_LOGIN_SUBMIT ---
      yandexMetrika.reachGoal('STEAM_LOGIN_SUBMIT');
      loginCorrect.value = true
    } else {
      loginCorrect.value = false
      steamInput.value.scrollIntoView({
        behavior: "smooth",
      });
    }
    res();
  })
}



const check_promocode = useDebounceFn(async function check_promocode() {
  await calcFormStore.checkPromocode(promoCode.value);

  discount_percent.value = calcFormStore.discount;
  promoCodeError.value = !calcFormStore.promocode;
  
  if (calcFormStore.promocode) {
    // --- ОТПРАВКА СОБЫТИЯ PROMO_CODE_APPLY ---
    yandexMetrika.reachGoal('PROMO_CODE_APPLY');
  }
}, 700)


onMounted(async () => {
  calcFormStore.getRates();
});

watch(() => calcFormStore.selectedCurrency, (newVal) => {
  validateBalance();
})

watch(() => calcFormStore.paymentType, newVal => {
  usernameChecking.then(() => {
    submitLogin();
  })
})

// Добавлен watch для установки начального значения balance, если оно не было установлено
watch(() => currencyStore.selectedCurrency, (newVal) => {
    if (calcFormStore.balance === 0.0) { // Проверка, чтобы не сбрасывать, если уже введено значение
      calcFormStore.balance = prices[newVal][0] || prices.RUB_RUB[0]; // Устанавливаем первое значение из массива
    }
  },
  // { immediate: true } // Выполнить немедленно при монтировании компонента
);
</script>

<style scoped>

</style>